<div class="timezone-display" (click)="openTimezoneDialog()">
  <mat-icon>schedule</mat-icon>
  <span class="timezone-text">{{ currentTime }} {{ timezone }}</span>
  <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
</div>
